// all values read from .env are strings, so we need to apply conversions to non-string values
const boolValue = (val: string | undefined) => val === 'true';

const apiEnvStorageKey = 'API_ENV';

export const NODE_ENV = process.env.NODE_ENV;
export const isProductionBuild = NODE_ENV === 'production';
export const APP_VERSION = process.env.APP_VERSION;
export const VERSION = process.env.VERSION;
export const DEV_MASQUERADE_LOGIN = process.env.DEV_MASQUERADE_LOGIN === 'true';
export const COMMITHASH = process.env.COMMITHASH;
if (NODE_ENV !== 'test') {
  // eslint-disable-next-line no-console
  console.log(`SBL v${VERSION} - ${COMMITHASH}`);
}
export const SBL_3701_PAPERWORK_LINK = boolValue(
  process.env.SBL_3701_PAPERWORK_LINK,
);
export const SHOW_HEADER_CREATE_BUTTON = boolValue(
  process.env.SHOW_HEADER_CREATE_BUTTON,
);
export const SHOW_DASHBOARD = boolValue(process.env.SHOW_DASHBOARD);
export const SHOW_VALIDATE_EAGLE = boolValue(process.env.SHOW_VALIDATE_EAGLE);

export const FEATURE_FLAG_EDITOR = boolValue(process.env.FEATURE_FLAG_EDITOR);

export const SHOW_USER_PERMISSIONS = boolValue(
  process.env.SHOW_USER_PERMISSIONS,
);
export const SHOW_SETTINGS_EXTRA_FIELDS = boolValue(
  process.env.SHOW_SETTINGS_EXTRA_FIELDS,
);
export const SHOW_YOUTH_PROFILE_EDIT = boolValue(
  process.env.SHOW_YOUTH_PROFILE_EDIT,
);
export const SHOW_YOUTH_PROFILE_INFORMATION = boolValue(
  process.env.SHOW_YOUTH_PROFILE_INFORMATION,
);
export const EDIT_YOUTH_PROFILE_POSITIONS = boolValue(
  process.env.EDIT_YOUTH_PROFILE_POSITIONS,
);
export const SHOW_EXTRA_PROFILE_FIELDS = boolValue(
  process.env.SHOW_EXTRA_PROFILE_FIELDS,
);
export const SHOW_OFFLINE_FEATURES = boolValue(
  process.env.SHOW_OFFLINE_FEATURES,
);
export const SHOW_MB_COUNSELORS = boolValue(process.env.SHOW_MB_COUNSELORS);
export const SHOW_YOUTH_ADV_REQUIREMENTS = boolValue(
  process.env.SHOW_YOUTH_ADV_REQUIREMENTS,
);
export const SBL_4688_ADD_INDIVIDUAL = boolValue(
  process.env.SBL_4688_ADD_INDIVIDUAL,
);
export const SHOW_ADVANCEMENTS_COMMENTS = boolValue(
  process.env.SHOW_ADVANCEMENTS_COMMENTS,
);
export const SHOW_SEA_ELECTIVES_DETAILS_ON_REQUIREMENTS = boolValue(
  process.env.SHOW_SEA_ELECTIVES_DETAILS_ON_REQUIREMENTS,
);
export const SBL_5060_ENABLE_HTML_EVENT_DESCRIPTION = boolValue(
  process.env.SBL_5060_ENABLE_HTML_EVENT_DESCRIPTION,
);
export const SHOW_RECORD_ADV_STATUS = boolValue(
  process.env.SHOW_RECORD_ADV_STATUS,
);

export const SHOW_COUNSELED_YOUTH = boolValue(process.env.SHOW_COUNSELED_YOUTH);

export const ALLOW_MBC_LOGIN = boolValue(process.env.ALLOW_MBC_LOGIN);
export const SHOW_ACTIVITIES_MENU = boolValue(process.env.SHOW_ACTIVITIES_MENU);
export const COMMISSIONER_ACCESS = boolValue(process.env.COMMISSIONER_ACCESS);
export const ALLOW_DELETE_ACTIVITIES = boolValue(
  process.env.ALLOW_DELETE_ACTIVITIES,
);

export const ENABLE_PROFILE_PICTURE_UPDATE = boolValue(
  process.env.ENABLE_PROFILE_PICTURE_UPDATE,
);
export const ENABLE_APPLE_SIGN_IN = boolValue(process.env.ENABLE_APPLE_SIGN_IN);

export const GOOGLE_SIGN_IN_CLIENT_ID = process.env.GOOGLE_SIGN_IN_CLIENT_ID;

export const STRIPE_QA_KEY = process.env.STRIPE_QA_KEY;
export const STRIPE_PROD_KEY = process.env.STRIPE_PROD_KEY;

export const SHOW_LOG_FILTERS = boolValue(process.env.SHOW_LOG_FILTERS);

export const ENABLE_EVENT_ACTIVITIES = boolValue(
  process.env.ENABLE_EVENT_ACTIVITIES,
);

export const ENABLE_EVENT_ADVANCEMENTS = boolValue(
  process.env.ENABLE_EVENT_ADVANCEMENTS,
);

export const ENABLE_EAGLE_PROJECT = boolValue(process.env.ENABLE_EAGLE_PROJECT);

export const ENABLE_SAND_BOX_MODAL = boolValue(
  process.env.ENABLE_SAND_BOX_MODAL,
);

export const SHOW_QUICK_ENTRY = boolValue(process.env.SHOW_QUICK_ENTRY);

export const SHOW_JOIN_DATE = boolValue(process.env.SHOW_JOIN_DATE);

export const SHOW_PERMISSION_MANAGER = boolValue(
  process.env.SBL_3906_PERMISSION_MANAGER,
);

export const SHOW_PERMISSIONS_TAB = boolValue(
  process.env.SBL_4142_PERMISSIONS_TAB,
);

export const SHOW_POSITIONS_TAB = boolValue(process.env.SBL_4142_POSITIONS_TAB);

export const SHOW_ROLES_TAB = boolValue(process.env.SBL_4142_ROLES_TAB);

export const SHOW_MESSAGING = boolValue(process.env.SBL_4143_SHOW_MESSAGING);

export const USE_UNITS_ROLETYPES = boolValue(process.env.USE_UNITS_ROLETYPES);

export const SHOW_LOGIN_WARNING = boolValue(process.env.SHOW_LOGIN_WARNING);

export const MAINTENANCE_END_DATE = process.env.MAINTENANCE_END_DATE;
export const MAINTENANCE_MESSAGE = process.env.MAINTENANCE_MESSAGE;

export const SBL_5198_CUB_BULK_ENTRY = boolValue(
  process.env.SBL_5198_CUB_BULK_ENTRY,
);

export const SBL_4832_EXPIRED_MEMBERSHIP_ACCESS = boolValue(
  process.env.SBL_4832_EXPIRED_MEMBERSHIP_ACCESS,
);

export const SBL_4724_PENDING_REQUIREMENTS = boolValue(
  process.env.SBL_4724_PENDING_REQUIREMENTS,
);

export const SBL_5499_COMPLETE_PROFILE_API = boolValue(
  process.env.SBL_5499_COMPLETE_PROFILE_API,
);

export const SBL_3444_BULK_YOUTH_LEADERSHIP_POSITIONS = boolValue(
  process.env.SBL_3444_BULK_YOUTH_LEADERSHIP_POSITIONS,
);

export const SBL_5033_SHOW_DOWNLOAD_SLIP = boolValue(
  process.env.SBL_5033_SHOW_DOWNLOAD_SLIP,
);

export const SBL_5140_DENCHIEF = boolValue(process.env.SBL_5140_DENCHIEF);

export const SBL_5026_DENCHIEF_CALENDAR = boolValue(
  process.env.SBL_5026_DENCHIEF_CALENDAR,
);

export const DISABLE_SERVICE_WORKER = boolValue(
  process.env.DISABLE_SERVICE_WORKER,
);

//
// DEV values
//
export const API_SWITCH_DEV =
  !isProductionBuild && boolValue(process.env.API_SWITCH_DEV);

export const ENABLE_MSW = boolValue(process.env.ENABLE_MSW);

// routes local RTK calls through the dev proxy so they are not bound to the
// handful of localhost origins ESB allows
export const RTK_PROXY = boolValue(process.env.RTK_PROXY);

const guessEnvFromURL = () => {
  const hostname = window.location.hostname.toLowerCase();
  const isLocalhost = Boolean(
    self.location.hostname === 'localhost' ||
      // [::1] is the IPv6 localhost address.
      self.location.hostname === '[::1]' ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      self.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
      ),
  );
  if (isLocalhost) {
    return 'local';
  }
  const [subdomainname] = hostname.split('.');
  switch (subdomainname.slice(-2)) {
    case 'dv':
      return 'dv';
    case 'qa':
      return 'qa';
    case 'pp':
      return 'pp';
    default:
      return 'pd';
  }
};

//
// config values that can be changed at runtime
//
export const initApiEnv = () => {
  if (!isProductionBuild && API_SWITCH_DEV) {
    return (
      localStorage.getItem(apiEnvStorageKey) ||
      process.env.API_ENV_DEFAULT ||
      ''
    );
  }
  const env = guessEnvFromURL();
  // default API env for local is qa
  if (env === 'local') {
    return 'qa';
  }
  return env;
};

export const ENV = guessEnvFromURL();
export const IS_PROD_ENV = ENV === 'pd';
export const IS_LOCAL_ENV = ENV === 'local';
export const IS_QA_ENV = ENV === 'qa';
export let API_ENV = initApiEnv();
export const setApiEnvConfig = (env: string) => {
  localStorage.setItem(apiEnvStorageKey, env);
  API_ENV = env;
};

//
// variables that should be passed in at build time, but need to be inferred at runtime for now
//

// the dev server port is configurable, so local API calls must stay same-origin
const LOCAL_ORIGIN = window.location.origin;

export const LOGIN_CAPTCHA = ['pd', 'dv', 'pp', 'qa'].includes(ENV);

export const GOOGLE_RECAPTCHA_INVI_SITE_KEY =
  process.env.GOOGLE_RECAPTCHA_INVI_SITE_KEY;

const getScoutbookLegacyLink = (env = '') =>
  `https://scoutbooklegacy${env}.scouting.org/mobile/dashboard/`;
/**
 * @todo change name to SCOUTBOOK_URL, old domain is already deprecated
 */
export const SCOUTBOOK_LEGACY_URL = (() => {
  switch (ENV) {
    case 'pd':
      return getScoutbookLegacyLink();
    case 'local': {
      return getScoutbookLegacyLink('qa');
    }
    default:
      return getScoutbookLegacyLink(ENV);
  }
})();

export const REPORTS_BASE_URL = (() => {
  const env = ENV === 'pd' ? '' : ENV === 'local' ? 'qa' : ENV;
  return `https://my${env}.scouting.org`;
})();

export const REPORTS_ALT_BASE_URL = (() => {
  if (ENV === 'local') return LOCAL_ORIGIN;
  return `https://reports${ENV}.scouting.org`;
})();

export const FORUMS_URL = `https://discussions${
  ENV === 'pd' ? '' : 'qa'
}.scouting.org`;

export const IA_HELP_URL =
  'https://help.scoutbook.scouting.org/article-categories/getting-started-with-internet-advancement-2-0/';

export const CORE_API_URLS: Record<string, string> = Object.freeze({
  dv: 'https://mydv.scouting.org',
  qa: 'https://myqa.scouting.org',
  pp: 'https://mypp.scouting.org',
  pd: 'https://my.scouting.org',
});

export const AUTH_API_URLS = Object.freeze({
  local: LOCAL_ORIGIN,
  dv: 'https://authdv.scouting.org',
  qa: 'https://authqa.scouting.org',
  pp: 'https://authpp.scouting.org',
  pd: 'https://auth.scouting.org',
});

export function getAuthUrl() {
  switch (ENV) {
    case 'dv':
      return AUTH_API_URLS.dv;
    case 'qa':
      return AUTH_API_URLS.qa;
    case 'pp':
      return AUTH_API_URLS.pp;
    case 'pd':
      return AUTH_API_URLS.pd;
    case 'local': {
      return AUTH_API_URLS.local;
    }
    default:
      return AUTH_API_URLS.pd;
  }
}

export const PAYMENT_API_URLS = Object.freeze({
  local: LOCAL_ORIGIN,
  dv: 'https://dvpayments.scouting.org',
  qa: 'https://qapayments.scouting.org',
  pp: 'https://pppayments.scouting.org',
  pd: 'https://payments.scouting.org',
});

export function getPaymentsUrl() {
  switch (ENV) {
    case 'dv':
      return PAYMENT_API_URLS.dv;
    case 'qa':
      return PAYMENT_API_URLS.qa;
    case 'pp':
      return PAYMENT_API_URLS.pp;
    case 'pd':
      return PAYMENT_API_URLS.pd;
    case 'local': {
      return PAYMENT_API_URLS.local;
    }
    default:
      return PAYMENT_API_URLS.pd;
  }
}

export const MYST_URLS = Object.freeze({
  local: LOCAL_ORIGIN,
  dv: 'https://mydv.scouting.org',
  qa: 'https://myqa.scouting.org',
  pp: 'https://mypp.scouting.org',
  pd: 'https://my.scouting.org',
});

export function getMYSTUrl() {
  switch (ENV) {
    case 'dv':
      return MYST_URLS.dv;
    case 'qa':
      return MYST_URLS.qa;
    case 'pp':
      return MYST_URLS.pp;
    case 'pd':
      return MYST_URLS.pd;
    case 'local': {
      return MYST_URLS.qa;
    }
    default:
      return MYST_URLS.pd;
  }
}

export const WEBSCRIPT_API_URLS = Object.freeze({
  ...CORE_API_URLS,
  pp: 'https://advancementspp.scouting.org',
});

export const ESB_API_URLS = Object.freeze({
  dv: 'https://apidv.scouting.org',
  qa: 'https://apiqa.scouting.org',
  pp: 'https://apipp.scouting.org',
  pd: 'https://api.scouting.org',
});

export const SB_URLS = Object.freeze({
  dv: 'https://scoutbookdv.scouting.org/',
  qa: 'https://scoutbookqa.scouting.org/',
  pp: 'https://scoutbookpp.scouting.org/',
  pd: 'https://scoutbook.scouting.org',
});

export const SB_PLUS_URLS = Object.freeze({
  dv: 'https://advancementsdv.scouting.org/',
  qa: 'https://advancementsqa.scouting.org/',
  pp: 'https://advancementspp.scouting.org/',
  pd: 'https://advancements.scouting.org/',
});

export const PAYMENTS_API_URLS = Object.freeze({
  dv: 'https://devpayments.scouting.org',
  qa: 'https://qapayments.scouting.org',
  pp: 'https://pppayments.scouting.org',
  pd: 'https://payments.scouting.org',
});

export const ENABLE_FORUM_URL =
  ENV === 'pd'
    ? 'https://fhc28j17j0.execute-api.us-east-1.amazonaws.com/prod/discourse-sync'
    : 'https://gvvevzlbfd.execute-api.us-east-1.amazonaws.com/prod/bsa-discourse-join-qa';

export const SCOUTSHOP_API_URLS = Object.freeze({
  dv: 'https://scoutbookdv.scoutshop.org',
  qa: 'https://scoutbook-staging.scoutshop.org',
  pp: 'https://scoutbook-staging.scoutshop.org',
  pd: 'https://scoutbook.scoutshop.org',
});

export const getScoutshopBaseURL = () => {
  switch (ENV) {
    case 'pd':
      return SCOUTSHOP_API_URLS.pd;
    case 'local':
      return LOCAL_ORIGIN;
    default:
      return SCOUTSHOP_API_URLS.pp;
  }
};

export function getScoutbookPlusURL() {
  switch (ENV) {
    case 'dv':
      return SB_PLUS_URLS.dv;
    case 'qa':
      return SB_PLUS_URLS.qa;
    case 'pp':
      return SB_PLUS_URLS.pp;
    case 'pd':
      return SB_PLUS_URLS.pd;
    case 'local': {
      return SB_PLUS_URLS.qa;
    }
    default:
      return SB_PLUS_URLS.pd;
  }
}

export const getScoutshopCartURL = (cartToken: string) =>
  `${
    ENV === 'local' ? SCOUTSHOP_API_URLS.pp : getScoutshopBaseURL()
  }/bsa/cart/sync/cart/${cartToken}/token`;

export const getSbPath = (env: string) =>
  `scoutbook${env === 'pd' ? '' : env}.scouting.org`;

export const getSbComSsoUrl = () => {
  switch (API_ENV) {
    case 'pd':
    case 'pp':
    case 'qa':
    case 'dv':
      return `https://${getSbPath(
        API_ENV,
      )}/mobile/includes/ajax.asp?Action=SBLtoScoutbookSSO`;
    default:
      throw new Error(`Unknown API_ENV ${API_ENV}`);
  }
};

export const getMyScoutingUrl = () => {
  switch (API_ENV) {
    case 'pd':
      return CORE_API_URLS.pd;
    case 'pp':
      return CORE_API_URLS.pp;
    case 'qa':
      return CORE_API_URLS.qa;
    case 'dv':
      return CORE_API_URLS.dv;
    default:
      throw new Error(`Unknown API_ENV ${API_ENV}`);
  }
};

export function getBaseESBUrl() {
  switch (API_ENV) {
    case 'pd':
      return ESB_API_URLS.pd;
    case 'pp':
      return ESB_API_URLS.pp;
    case 'qa':
      return ESB_API_URLS.qa;
    case 'dv':
      return ESB_API_URLS.dv;
    default:
      throw new Error(`Unknown API_ENV ${API_ENV}`);
  }
}

export const getLocalhostOrigin = () =>
  `https://scoutbook${API_ENV}.scouting.org`;

export const getPreciselyUrl = () => `https://api.cloud.precisely.com`;

export const getPromoteScoutsURL = (orgGUID: string) =>
  `https://my${API_ENV}.scouting.org/${orgGUID}/organization-manager/roster`;

export const getYPTCertificateURL = (
  memberId: string,
  personGuid: string,
  enrollmentId: number,
) => {
  const certUrl = `/vim2/webscript/output/proxy.aspx?Method=ExecuteScriptSet&ScriptCode=TrainingCertificatePDF&ScriptSetCode=TrainingCertificate&MemberID=${memberId}&PersonGUID=${personGuid}&EnrollmentID=${enrollmentId}`;
  return `${getMYSTUrl()}${certUrl}`;
};

export const getArnicaRootUrl = () => {
  switch (ENV) {
    case 'pd':
      return `${MYST_URLS.pd}/vim2/WebScript/Output/proxy.aspx`;
    case 'pp':
      return `${MYST_URLS.pp}/vim2/WebScript/Output/proxy.aspx`;
    case 'qa':
      return `${MYST_URLS.qa}/vim2/WebScript/Output/proxy.aspx`;
    case 'dv':
      return `${MYST_URLS.dv}/vim2/WebScript/Output/proxy.aspx`;
    case 'local':
      return `${MYST_URLS.local}/vim2/WebScript/Output/proxy.aspx`;
    default:
      throw new Error(`Unknown API_ENV ${API_ENV}`);
  }
};
